import {backAdmin} from "@/lib/api/axios";

export const userApi = [
   {url: `${backAdmin}/users`, name: 'user.all', method: 'GET'},
   {url: `${backAdmin}/users/{id}`, name: 'user.id', method: 'GET'},
   {url: `${backAdmin}/users/{id}`, name: 'user.update', method: 'PUT'},
   {url: `${backAdmin}/users/{id}`, name: 'user.delete', method: 'DELETE'},
   {url: `${backAdmin}/users/{id}/subscription-history`, name: 'user.subscription.history', method: 'GET'},
   {url: `${backAdmin}/users/{id}/backups`, name: 'user.backups', method: 'GET'},
   {url: `${backAdmin}/backups/{id}/restore`, name: 'backup.restore', method: 'POST'},
   {url: `${backAdmin}/backups/{id}`, name: 'backup.delete', method: 'DELETE'},
]